module.exports = __webpack_public_path__ + "img/27.15cb085e.png";